import type { FilterChip, Lookups } from "../../types";
import { buildRangeLabel } from "../../utils/buildRangeLabel";
import type { ItSpendSlice } from "../itSpend/slice";

export function getChips(
  slice: ItSpendSlice,
  setSlice: (s: ItSpendSlice) => void,
  lookups?: Lookups
): FilterChip[] {
  const aiCategoriesById = new Map(
    (lookups?.aiSpendCategories ?? []).map((c) => [c.id, c.name])
  );

  return slice.rows
    .map((row, index) => ({ row, index }))
    .filter(({ row }) => !!row.categoryId)
    .map(({ row, index }) => {
      const categoryId = row.categoryId as string;
      const categoryLabel = aiCategoriesById.get(categoryId) ?? categoryId;
      const rangeLabel = buildRangeLabel(row.min, row.max, {
        isCurrency: true,
      });
      const label = rangeLabel
        ? `${categoryLabel}: ${rangeLabel}`
        : categoryLabel;

      return {
        id: `aiSpend-${categoryId}-${index}`,
        label: `AI Spend: ${label}`,
        filterKey: "aiSpend" as const,
        onRemove: () => {
          const nextRows = slice.rows.filter((_, i) => i !== index);
          setSlice({ rows: nextRows.length > 0 ? nextRows : [{}] });
        },
      };
    });
}
